"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handlePreInit = void 0;
var tslib_1 = require("tslib");
var mtTracker_1 = tslib_1.__importDefault(require("../trackers/mtTracker"));
var typings_1 = require("../typings");
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var util_1 = require("../utils/util");
function entryGen(TrackerCtor) {
    var started = false;
    var tracker = null;
    var perfActionByName = {
        init: function (options) {
            var _a;
            if (started)
                return false;
            started = true;
            tracker = new TrackerCtor(options);
            if ((_a = options === null || options === void 0 ? void 0 : options.common) === null || _a === void 0 ? void 0 : _a.dev) {
                logger_1.default.setDebug();
            }
            return true;
        },
        /**
         * 设置全局自定义tag
         * @param tags 自定义tag key/value
         */
        setTag: function (tags) {
            if (started) {
                tracker === null || tracker === void 0 ? void 0 : tracker.setTag(tags);
            }
        },
        /** 老通道自定义指标 后续废除 */
        reportPerformance: function (type, value, tags) {
            if (started && tracker) {
                tracker.reportPerformance(type, value, tags);
            }
        },
        addError: function (error, level) {
            if (level === void 0) { level = typings_1.LEVEL.ERROR; }
            if (started && tracker) {
                tracker.addError(error, level);
            }
        },
        addRequest: function (req) {
            if (started && tracker) {
                tracker.addRequest(req);
            }
        },
        use: function (pluginCtors) {
            if (started) {
                logger_1.default.warn('perf已初始化，请在初始化前加载插件');
                return;
            }
            if (util_1.isArray(pluginCtors)) {
                pluginCtors.forEach(function (pluginCtor) {
                    TrackerCtor.use(pluginCtor);
                });
            }
            else {
                TrackerCtor.use(pluginCtors);
            }
        },
        /** 新通道自定义指标 */
        addCustomMetrics: function (type, value, tags) {
            if (started && tracker) {
                tracker.addCustomMetrics(type, value, tags);
            }
        },
    };
    var actionNames = Object.keys(perfActionByName);
    /** 如果在非容器环境使用容器环境的 SDK 直接默认空函数 */
    if (TrackerCtor === mtTracker_1.default && !util_1.getTitansVersion()) {
        util_1.clearLoader();
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return function perf() { };
    }
    // 对外暴露函数 而不是对象 便于在通过 script 标签引入时，做资源加载失败时 容错处理
    return function perf(key) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        if (actionNames.indexOf(key) > -1) {
            var perfAction = perfActionByName[key];
            perfAction.apply(void 0, rest);
        }
    };
}
exports.default = entryGen;
function handlePreInit(perf) {
    var _perf_ = window._perf_ || {};
    if (_perf_.initOptions) {
        perf('init', _perf_.initOptions);
    }
}
exports.handlePreInit = handlePreInit;
//# sourceMappingURL=base.js.map